{
	"letterhead": "Événement '{{name}} ({{begin}})'",
	"notAuthorized": "Vous n'êtes pas autorisé à consulter les rapports de cette section"
}
